import { createSelector, isConsumer } from '../../shared';
import type { AppState } from '..';
import { isFeatureEnabled } from 'owa-feature-flags';

export const isPublicFoldersEnabled = createSelector<AppState, string, boolean>(
    'isPublicFoldersEnabled',
    [(appState: AppState) => appState.data.userConfiguration.settings.DefaultPublicFolderMailbox],
    defaultPublicFolderMailbox => {
        return (
            isFeatureEnabled('people-publicFolders') &&
            !isConsumer() &&
            !!defaultPublicFolderMailbox
        );
    }
);
